import React from 'react';
import { Alert } from '../components/ui/alert';

export interface Timecard {
  clock_in: string | null;
  clock_out: string | null;
}

export function formatTimestamp(timestamp: string): string {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function formatDuration(clockIn: string, clockOut: string): string {
  const diffMs = new Date(clockOut).getTime() - new Date(clockIn).getTime();
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
}

const TimecardDisplay: React.FC<{ timecards: Timecard[] | null }> = ({ timecards }) => {
  return (
    <div className="space-y-3">
      {timecards && timecards.length > 0 ? (
        timecards.map((session, index) => (
          <div key={index} className="flex items-center justify-center gap-3 text-sm flex-wrap">
            {session.clock_in && session.clock_out ? (
              <>
                <Alert variant="success" className="shrink-0">
                  Completed
                </Alert>
                <span className="text-foreground">
                  <span className="font-medium">In:</span> {formatTimestamp(session.clock_in)}
                </span>
                <span className="text-foreground">
                  <span className="font-medium">Out:</span> {formatTimestamp(session.clock_out)}
                </span>
                <span className="text-foreground">
                  <span className="font-medium">Duration:</span> {formatDuration(session.clock_in, session.clock_out)}
                </span>
              </>
            ) : session.clock_in ? (
              <>
                <Alert variant="warning" >
                  Incomplete
                </Alert>
                <span className="text-foreground">
                  <span className="font-medium">In:</span> {formatTimestamp(session.clock_in)}
                </span>
                <Alert variant="warning" >
                  No Clock Out
                </Alert>
              </>
            ) : (
              <>
                <Alert variant="warning" className="shrink-0">
                  Incomplete
                </Alert>
                <span className="text-gray-600">No Clock In</span>
                <span className="text-gray-600">No Clock Out</span>
              </>
            )}
          </div>
        ))
      ) : (
        <div className="text-base text-gray-500">&nbsp;</div>
      )}
    </div>
  );
};

export default TimecardDisplay;